module.exports = __webpack_public_path__ + "media/images/riders/DANIEL_MCCONNELL-7c826cb1010e3663b9171e1ed5eac20c.png";